"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendCodeSms = sendCodeSms;
var _index = require("./index");
var _sendCode = require("../../api/sendCode");
var _view = require("../../types/view");
var _view2 = require("../view");
var _sendTwoFactorCode = require("../../api/sendTwoFactorCode");
// TODO удалить, скорее всего больше не пригодится. Не забыть убирать весь связанный с этим экшеном код
function sendCodeSms() {
  return async (dispatch, getState, context) => {
    const {
      subdomain
    } = context;
    const state = getState();
    const phone = state.authentication.twoFactor.phoneState.phone;
    const login = state.login;
    const activeView = state.view.active;
    dispatch((0, _index.sendCodeLoading)());
    const result = await (0, _sendTwoFactorCode.sendTwoFactorCodeSms)(context, {
      login,
      phone,
      subdomain
    });
    if (result.status !== _sendTwoFactorCode.ESendTwoFactorCodeStatus.Succeed) {
      dispatch((0, _index.sendCodeFailed)(result.message));
      return;
    }
    dispatch((0, _index.sendCodeSucceed)(result));
    if (result.senderType === _sendCode.ESenderType.Sms && activeView !== _view.EActiveView.TwoFactorPhoneValidateSms) {
      dispatch((0, _view2.changeView)(_view.EActiveView.TwoFactorPhoneValidateSms));
    }
  };
}